export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10433.fe58015f.jpg";